module.exports = __webpack_public_path__ + "static/privacy-1-ff5105480706650ec6bcbdfa7f5ba8be.svg";